module.exports = __webpack_public_path__ + "static/media/roboto-v29-latin-300.80fe119e.woff2";